import * as React from 'react';
import { createContext, useContext, useState } from 'react';
import {
  ITicketsNextBackState,
  ITicketsNextBackStateContext
} from './TicketsNextBackStateContext.types';

const initialContext: ITicketsNextBackState = {
  currentIndex: 0,
  currentPageInfo: null,
  ticketIds: [],
  currentFilter: null,
  currentSortBy: null,
  previousClickedButton: null
};

export const TicketsNextBackStateContext = createContext<ITicketsNextBackStateContext>(
  {
    ticketsNextBackState: initialContext,
    setTicketsNextBackState: () => undefined
  }
);

export const TicketsNextBackStateContextProvider: React.FC = ({ children }) => {
  const [ticketsNextBackState, setTicketsNextBackState] = useState<
    ITicketsNextBackState
  >(initialContext);

  return (
    <TicketsNextBackStateContext.Provider
      value={{ ticketsNextBackState, setTicketsNextBackState }}
    >
      {children}
    </TicketsNextBackStateContext.Provider>
  );
};

export const useTicketsNextBackStateContext = () =>
  useContext<ITicketsNextBackStateContext>(TicketsNextBackStateContext);
